import { makeObservable, action } from "mobx";
import { ProjectPlan } from '../api';

export default class ProjectPlanStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      getProjectPlans: action,
      createProjectPlan: action,
      getProjectPlanById: action,
      getProjectPlanByEmail: action,
      updateProjectPlanById: action,
      updateProjectPlanByEmail: action
    });
  }

  async getProjectPlans() {
    try {
      const retObj = await ProjectPlan.getProjectPlans();
      return retObj.data.response.projectPlans;
    } catch (error) {
      console.error("Error in getProjectPlans:", error);
      throw error;
    }
  }

  async createProjectPlan(data) {
    try {
      const retObj = await ProjectPlan.createProjectPlan(data);
      return retObj.data.response.projectPlan;
    } catch (error) {
      console.error("Error in createProjectPlan:", error);
      throw error;
    }
  }

  async getProjectPlanById(id) {
    try {
      const retObj = await ProjectPlan.getProjectPlanById(id);
      return retObj.data.response.projectPlan;
    } catch (error) {
      console.error("Error in getProjectPlanById:", error);
      throw error;
    }
  }

  async getProjectPlanByEmail(email) {
    try {
      const retObj = await ProjectPlan.getProjectPlanByEmail(email);
      return retObj.data.response.projectPlans;
    } catch (error) {
      console.error("Error in getProjectPlanByEmail:", error);
      throw error;
    }
  }

  async updateProjectPlanById(id, data) {
    try {
      const retObj = await ProjectPlan.updateProjectPlanById(id, data);
      return retObj.data.response.projectPlan;
    } catch (error) {
      console.error("Error in updateProjectPlanById:", error);
      throw error;
    }
  }

  async updateProjectPlanByEmail(data, email) {
    try {
      const retObj = await ProjectPlan.updateProjectPlanByEmail(data, email);
      return retObj;
    } catch (error) {
      console.error("Error in updateProjectPlanByEmail:", error);
      throw error;
    }
  }
}
